export function processReportJson(data: any): any[] {
    let json = data.map((it: any) => {
        return {
            Codice: `${it.id}-${it.ctName}`,
            Tipologia: it.ctType,
            "Totale Commissionabile": it.totalCommissionable*0.01 || 0,
            "Importo Royalties da fatturare": it.totalRoyaltyToBill*0.01 || 0
        }
    });
    let totalObj = {
        Codice: "TOTALE",
        Tipologia: "",
        "Totale Commissionabile": json.map((it: any) => it["Totale Commissionabile"]).reduce((it1: number, it2: number) => it1 + it2, 0),
        "Importo Royalties da fatturare": json.map((it: any) => it["Importo Royalties da fatturare"]).reduce((it1: number, it2: number) => it1 + it2, 0)
    }
    json.push(totalObj);
    return json;
}


export function downloadPDF(pdf: string, data: any) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    let tmp =data.filePath.substring(data.filePath.lastIndexOf("/")+1);
    const fileName = tmp.substring(0, tmp.lastIndexOf(".")) + ".pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}